export default __webpack_public_path__ + "static/media/Yet_Another_Resume.ab9a0394.pdf";